import { styled } from 'mz-ui-kit'

export const Container = styled('div', {
  fontSize: '14px',
  lineHeight: 'normal',
  fontWeight: 'bold',
  display: 'flex',
  justifyContent: 'flex-end',
  minWidth: '45px',
  marginRight: '10px',
});

export const ButtonWrapper = styled('div', {
  height: '35px',
  width: '35px',
  position: 'relative',
  display: 'flex',
  flexFlow: 'row nowrap',
  zIndex: 1000,
});
